var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 32,
    height: 32,
    transform: "translate(1790 800)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u062A\\u0646\\u0638\\u06CC\\u0645\\u0627\\u062A",
    transform: "translate(-1790 -800)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M34.258,21.333a5.462,5.462,0,0,1,3.076-4.649A16.951,16.951,0,0,0,36.017,13.5a5.151,5.151,0,0,1-5.166-1.683,4.99,4.99,0,0,1-1.3-5.166,16.725,16.725,0,0,0-3.183-1.317A6.022,6.022,0,0,1,21.333,8.41,6.034,6.034,0,0,1,16.3,5.335a16.725,16.725,0,0,0-3.183,1.317,4.994,4.994,0,0,1-1.3,5.166A5.155,5.155,0,0,1,6.658,13.5a16.231,16.231,0,0,0-1.325,3.183,5.455,5.455,0,0,1,3.084,4.649,6.043,6.043,0,0,1-3.084,5.033A16.725,16.725,0,0,0,6.65,29.55a4.976,4.976,0,0,1,5.158,1.3,4.974,4.974,0,0,1,1.3,5.166,16.951,16.951,0,0,0,3.183,1.317,6.032,6.032,0,0,1,5.033-3.076,6.032,6.032,0,0,1,5.033,3.076,16.725,16.725,0,0,0,3.183-1.317,4.994,4.994,0,0,1,1.3-5.166,5.163,5.163,0,0,1,5.166-1.683,17.183,17.183,0,0,0,1.317-3.183,5.452,5.452,0,0,1-3.066-4.649ZM21.333,29.525a8.192,8.192,0,1,1,8.192-8.192A8.2,8.2,0,0,1,21.333,29.525Z",
    transform: "translate(1784.667 794.666)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cb1ca2e7fd928ecfefd83603a7fd1411.svg";
export { ForwardRef as ReactComponent };